import type { Appointment } from "@/features/appointments/types/appointmentTypes";
import { AppointmentStatusBadge } from "@/features/appointments/components/AppointmentStatusBadge";
import type { Service } from "@/features/services/types/serviceTypes";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { InfoRow } from "@/shared/components/ui/InfoRow";
import { formatBusinessDate } from "@/shared/utils/formatters";
import { LucideCalendar } from "lucide-react";

interface ClientAppointmentCardProps {
  appointment: Appointment;
  services: Service[];
  onClick: () => void;
}

export function ClientAppointmentCard({
  appointment,
  services,
  onClick,
}: ClientAppointmentCardProps) {
  const { business } = useCurrentBusiness();
  const serviceName = appointment.services.map((booked) => services.find((service) => service.id === booked.serviceId)?.name || "Unavailable service").join(", ") || "No service";
  return (
    <InfoRow
      title={serviceName}
      density="compact"
      caption={
        appointment.startAt
          ? formatBusinessDate(appointment.startAt, business?.timezone || "UTC", {
            weekday: "short", day: "numeric", month: "short", year: "numeric",
            hour: "numeric", minute: "2-digit",
          })
          : "No date set"
      }
      icon={<LucideCalendar className="size-5 text-primary" aria-hidden="true" />}
      trailing={<AppointmentStatusBadge status={appointment.status} />}
      onClick={onClick}
    />
  );
}
